import { computed } from 'vue'
// types
import type { BtnPrimaryLinkHookOptions, BtnPrimaryLinkHookReturn } from '../types/interfaces'

export const useBtnPrimaryLink = ({ props }: BtnPrimaryLinkHookOptions): BtnPrimaryLinkHookReturn => {
  const refIsExternal = computed<boolean>(() => /^https?:\/\//.test(props.href))

  const classList = computed<string[]>(() => [
    'ui-btn-primary',
    `ui-btn-primary--${props.color}`,
    `ui-btn-primary--${props.size}`,
    `ui-btn-primary--${props.elementWidth}`,
  ])

  const refLinkAttrs = computed<Record<string, string | undefined>>(() => {
    const attrs: Record<string, string | undefined> = {}
    if (props.target) attrs.target = props.target
    if (props.rel) attrs.rel = props.rel
    else if (props.target === '_blank') attrs.rel = 'noopener noreferrer'
    return attrs
  })

  return {
    refIsExternal,
    classList,
    refLinkAttrs,
  }
}